/**
 * rondo-web-forms
 *
 * Rondo Web Forms
 *
 * @author Jiri Hybek <jiri@hybek.cz>
 * @license See LICENSE file distributed with this source code.
 */

import React, { useMemo } from "react";

import { FormModel } from "../../../shared/FormModel/FormModel";
import { bem } from "../../../shared/BEM";
import { useFormModel } from "../../../shared/hooks/useFormModel";
import { ButtonSubmit } from "../Common/ButtonSubmitComponent";
import { ButtonGroup } from "../Common/ButtonGroupComponent";

/**
 * Component props
 */
export interface IFormActionBarComponentProps {
	model: FormModel
}

export function FormActionBarComponent(props: IFormActionBarComponentProps) {

	const downloadPDF = useMemo(() => () => {

		const formConfig = props.model.getConfig();
		const formData = props.model.getData();

		return {
			method: "post",
			path: `/api/download/pdf/${formConfig.id}/${formConfig.version}`,
			data: formData,
			target: "_blank"
		};

	}, [ props.model ]);

	const saveAs = useMemo(() => () => {

		const formConfig = props.model.getConfig();
		const formData = props.model.getData();

		return {
			method: "post",
			path: `/api/download/json/${formConfig.id}/${formConfig.version}`,
			data: formData
		};

	}, [ props.model ]);

	const stl = bem("form-actionbar");

	return <div className={stl.str}>
		<ButtonGroup flow="row" align="center">
			<ButtonSubmit
				label="Uložit jako"
				icon="content-save"
				style="primary"
				size="large"
				width="medium"
				onSubmit={saveAs}
			/>
			<ButtonSubmit
				label="Stáhnout PDF"
				icon="file-pdf"
				style="pdf"
				size="large"
				width="medium"
				onSubmit={downloadPDF}
			/>
		</ButtonGroup>
	</div>;

}